exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagination-nav {\r\n\tmargin-top: 15px;\r\n\tfloat: right;\r\n}\r\n\r\n.btn-outline-primary {\r\n\tcolor: #153764;\r\n\tborder-color: #153764;\r\n\tline-height: 16px;\r\n\tfont-size: smaller;\r\n}\r\n\r\n.btn-outline-primary:hover,\r\n.btn-outline-primary:focus{\r\n\tcolor: #fff;\r\n\tbackground-color: #153764;\r\n\tborder-color: #153764;\r\n}\r\n.active{\r\n\tcolor: #fff;\r\n\tbackground-color: #153764;\r\n\tborder-color: #153764;\r\n  }\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/view-prepaid-transaction/view-prepaid-transaction.component.css
// module id = ../../../../../src/app/components/view-prepaid-transaction/view-prepaid-transaction.component.css
// module chunks = 0